<template>
  <b-container fluid>
    <div class="d-block d-md-none">
      <sidebar title="Edit Job" :isMobile="true" :tabs="tabs" @changeTab="updateTab" />
    </div>
    <div class="d-none d-md-block">
      <sidebar title="Edit Job" :isMobile="false" :tabs="tabs" @changeTab="updateTab" />
    </div>
    <b-spinner v-if="loading" label="Spinning"></b-spinner>
    <router-view v-else :job="job" @publish="publish" @updateJobDetails="updateJobDetails" @reopen="reopen"></router-view>
  </b-container>
</template>
<script>
import {mapState} from 'vuex';

import Job from '@/fstore/collections/Job';
import Screening from '@/fstore/collections/Screening';

export default {
  name: "jobDetails",
  components:{
    sidebar: () => import('@/components/Sidebar'),
  },
  data: () => {
    return {
      loading: false,
      job: {},
      currentTab: 'details',
      tabs: [
        { 
          title: 'details',
          icon: 'layout-text-window',
          name: 'jobDetails'
        },
        {
          title: 'candidates',
          icon: 'person-fill',
          name: 'jobCandidates',
        },
        {
          title: 'Jobs List',
          icon: 'arrow-bar-left',
          name: 'companyJobs',
          query: {}
        }
      ]
    }
  },
  computed: mapState({
    company: state => state.company.data
  }),
  async created () {
    try {
      this.loading = true;
      this.job = await Job.getById(this.$route.params.id);
      this.tabs[2].query.id = this.job.company.id;
      this.loading = false;
    }catch(err) {
      this.loading = false;
      console.log(err);
    }
  },
  methods: {
    updateTab(tab) {
      this.currentTab = tab;
    },
    publish() {
      this.job.published = new Date();
      this.updateJobDetails()
    },
    async updateJobDetails() {
      this.$store.dispatch('app/setOverlay', true);
      await Job.update(this.job.uid, this.job);
      this.$store.dispatch('app/setOverlay', false);

      this.$store.dispatch("app/setAlert", {
        type: "success",
        message: 'job details updated successfully.'
      }); //end dispatch alert
    },
    async reopen() {
      this.$store.dispatch('app/setOverlay', true);
      await Screening.removeScreeningsForJob(this.job.uid);
      this.job.closed = null;
      this.job.created = new Date();
      await Job.update(this.job.uid, this.job);
      this.$store.dispatch('app/setOverlay', false);
    }
  }
}
</script>